
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 56 56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#E9E9E0","d":"M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z"}}),_c('path',{attrs:{"fill":"#D9D7CA","d":"M37.5.151V12h11.849z"}}),_c('path',{attrs:{"fill":"#95A5A5","d":"M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z"}}),_c('path',{attrs:{"fill":"#C8BDB8","d":"M18.5 13h-6a1 1 0 110-2h6a1 1 0 110 2zM21.5 18h-9a1 1 0 110-2h9a1 1 0 110 2zM25.5 18c-.26 0-.521-.11-.71-.29-.181-.19-.29-.44-.29-.71s.109-.52.3-.71c.36-.37 1.04-.37 1.41 0 .18.19.29.45.29.71 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29zM37.5 18h-8a1 1 0 110-2h8a1 1 0 110 2zM12.5 33c-.26 0-.521-.11-.71-.29-.181-.19-.29-.45-.29-.71 0-.26.109-.52.29-.71.37-.37 1.05-.37 1.42.01.18.18.29.44.29.7 0 .26-.11.52-.29.71-.19.18-.45.29-.71.29zM24.5 33h-8a1 1 0 110-2h8a1 1 0 110 2zM43.5 18h-2a1 1 0 110-2h2a1 1 0 110 2zM34.5 23h-22a1 1 0 110-2h22a1 1 0 110 2zM43.5 23h-6a1 1 0 110-2h6a1 1 0 110 2zM16.5 28h-4a1 1 0 110-2h4a1 1 0 110 2zM30.5 28h-10a1 1 0 110-2h10a1 1 0 110 2zM43.5 28h-9a1 1 0 110-2h9a1 1 0 110 2z"}})])
          )
        }
      }
    